module.exports = __webpack_public_path__ + "static/media/team-4-470x470.7d13384c.png";